import { onMounted } from "vue";
import { loadLocaleMessages } from "@/plugins/i18n";
import { getErrorBannerInfo } from "@/utils/error.banner.util.ts";

export function useErrorBanner() {
  onMounted(async () => {
    await loadLocaleMessages("error");
  });

  return { getErrorBannerInfo };
}
